module.exports = __FOREMAN_VENDOR__REACT_ROUTER_DOM__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_ROUTER_DOM__"
// module id = react-router-dom
// module chunks = 0